import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonHeaderComponent } from '../../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'donottravel',
  standalone: true,
  imports: [FooterComponent, CommonHeaderComponent, CommonModule],
  templateUrl: './donottravel.component.html',
  styleUrl: './donottravel.component.scss',
})
export class DonottravelComponent {
  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {}
  pageContent: SafeHtml = '';
  pageTitleImg: string = '';
  pageHead: string = '';

  ngOnInit() {
    this.titleService.setTitle(
      'Do Not Travel Advisory | COVID-19 Update | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover travel insurance update: no cover applies for trips booked after the government’s ‘Do Not Travel’ COVID-19 advisory issued in March 2020.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Do Not Travel Advisory | COVID-19 Update | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover travel insurance update: no cover applies for trips booked after the government’s ‘Do Not Travel’ COVID-19 advisory issued in March 2020.',
    });
    this.pageTitleImg = 'assets/images/w2c/page-header/travel-alerts.jpg';
    this.pageHead = 'Do Not Travel Advisory - COVID-19';
  }
}
